module.exports = __webpack_public_path__ + "static/media/31.f7a61f3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/31.png
// module id = 885
// module chunks = 0